export class SeriesMeetingModel {
  public id: string;
  public title: string;
  public label: string;
  public description: string;
  public programType: string;
  public price: number;
  public duration: number;
  public mandatory: boolean;
  public remoteMandatory: boolean;
  public localMandatory: boolean;
  public classroomType: string
  public prerequisites: string;
  public agenda: string;
  public preparation: string;

  constructor(init?: Partial<SeriesMeetingModel>) {
    Object.assign(this, init);
  }
}


export class MeetingSeriesDetails {
  public title: string;
  public meetings: SeriesMeetingModel[];

  constructor(init?: Partial<MeetingSeriesDetails>) {
    Object.assign(this, init);
  }
}
